import { useTranslation } from 'react-i18next';

export const NoDependenciesOverlay = () => {
  const { t } = useTranslation();
  return (
    <div className="flex h-full items-center justify-center py-4 text-center text-sm text-text-neutral-secondary">
      {t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.noDependencies)}
    </div>
  );
};
